import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmptyStateComponent } from '@y42/core/empty-state';
import { DataNoRowOverlayComponent } from './data-no-row-overlay.component';

@NgModule({
  imports: [CommonModule, EmptyStateComponent],
  declarations: [DataNoRowOverlayComponent],
  exports: [DataNoRowOverlayComponent],
})
export class DataNoRowOverlayModule {}
